var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-2.5 -2.5 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.3 15 H 19.3 C 20.6 15 21.9 15.5 22.8 16.5 C 23.8 17.4 24.3 18.7 24.3 20 C 24.3 21.3 23.8 22.6 22.8 23.5 C 21.9 24.5 20.6 25 19.3 25 L 8.3 25 V 6 L 17.8 6 C 19 6 20.1 6.5 21 7.3 C 21.8 8.2 22.3 9.3 22.3 10.5 C 22.3 11.7 21.8 12.8 21 13.7 C 20.1 14.5 19 15 17.8 15",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightRegular);
export default __webpack_public_path__ + "static/media/weight-regular.dc9b035cf807771db353cc160a3ed0cd.svg";
export { ForwardRef as ReactComponent };